import b64toBlob from 'b64-to-blob';

class LocalStorageDB {
  constructor() { }
  getKeys() {
    let data = localStorage.getItem("db_keys")
    if (!data) {
      return [];
    } else {
      return JSON.parse(data);
    }
  }
  addKey(key) {
    let keys = this.getKeys();
    keys.push(key);
    localStorage.setItem("db_keys", JSON.stringify(keys));
  }
  clearDatabase(except = []) {
    let keys = this.getKeys().filter(v => except.indexOf(v) === -1);
    keys.forEach(key => {
      localStorage.removeItem(key);
    });
    localStorage.setItem("db_keys", JSON.stringify(except));
  }
  hasKey(store, id) {
    let key = (store + "_" + id).toUpperCase();
    if (localStorage.getItem(key)) {
      return true;
    }
    return false;
  }
  remove(store, id) {
    let key = (store + "_" + id).toUpperCase();
    let keys = this.getKeys();
    let newKeys = [];
    keys.forEach(item => {
      if (item === key) {
        localStorage.removeItem(item);
      } else {
        newKeys.push(item);
      }
    });
    localStorage.setItem("db_keys", JSON.stringify(newKeys));
  }
  saveObject(store, id, object) {
    let key = (store + "_" + id).toUpperCase();
    if (!this.hasKey(store, id)) {
      this.addKey(key);
    }
    localStorage.setItem(key, JSON.stringify(object));
  }
  getObject(store, id) {
    let key = (store + "_" + id).toUpperCase();
    return new Promise(function (resolve, reject) {
      let data = localStorage.getItem(key);
      if (!data) {
        reject(id + " is not found");
      } else {
        resolve(JSON.parse(data));
      }
    });
  }
  getStoreObjects(store) {
    return new Promise((resolve, reject) => {
      try {
        let data = [];
        let keys = this.getKeys();
        for (let key of keys) {
          if (key.split('_')[0] === store.toUpperCase()) {
            let item = localStorage.getItem(key);
            if (item) {
              data.push(item);
            }
          }
        }
        resolve(data);
      } catch (err) {
        reject("unable to get store " + store);
      }
    });
  }
  saveFile(store, id, file) {
    return new Promise((resolve, reject) => {
      try {
        let key = (store + "_" + id).toUpperCase();
        let reader = new FileReader();
        if (!this.hasKey(store, id)) {
          this.addKey(key);
        }
        reader.onload = (e) => {
          try {
            localStorage.setItem(key, file.name + ";" + e.target.result);
            resolve(id);
          } catch (err) {
            reject("Local storage limit exceeded");
          }
        };
        reader.readAsDataURL(file);
      } catch (err) {
        reject(err);
      }
    });
  }
  getFile(store, id) {
    let key = (store + "_" + id).toUpperCase();
    return new Promise(function (resolve, reject) {
      let data = localStorage.getItem(key);
      if (!data) {
        reject(id + " is not found");
      } else {
        let base64Parts = data.split(';');
        let contentType = base64Parts[1].split(':')[1];
        let b64Data = base64Parts[2].split(',')[1];;
        let blob = b64toBlob(b64Data, contentType);
        blob.name = base64Parts[0]; // file name
        resolve(blob);
      }
    }
    );
  }
}

var localStorageDB = new LocalStorageDB();

export default localStorageDB;



// WEBPACK FOOTER //
// ./src/services/LocalDatabase/LocalStorageDB.js